import { Box } from '@montugroup/design-system';
import { styled } from '@mui/material';

export const TextContainer = styled(Box)(({ theme }) => ({
  padding: `0 ${theme.spacing(34)}`,
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    padding: 0,
  },
}));
